import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

import "../../../sass/views/dashboard/insurances/insurances.scss";
import { useTranslation } from "react-i18next";
import Layout from "../../../components/layout/Layout";

import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { FiDownload } from "react-icons/fi";
import { LOCALES } from "common/constants";

export const InsuranceContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let language = localStorage.getItem("i18nextLng");
  const FörsäkringsbrevTryggHansa = `${blobURL}/Försäkringsbrev.pdf`;

  return (
    <section className="newdesign">
      <div className="container p-0">
        <div className="without_background">
          <div className="d-flex">
            <div>
              <h1 className="purple">
                {t(
                  "Invozio's Insurance: Comprehensive Protection for Self-Employed Individuals"
                )}
              </h1>
              <p className="insurance_para">
                {t(
                  "Invoicing without a company offers flexibility and freedom, but it also means you need to consider having adequate insurance coverage. Invozio, a leading service for self-employed individuals, offers a comprehensive insurance package that protects you when you perform work through their platform."
                )}
              </p>

              <blockquote className="blockquote_txt">
                {t(
                  "“In this article, we go through the most important insurances that Invozio offers, so that you can feel safe and secure while working,” says Didrik Selder, CEO at Invozio."
                )}
              </blockquote>
            </div>

            <div className="download-box h-100 shadow p-2 col-md-6 col-lg-3">
              <div className="inner-box d-flex align-items-center justify-content-between">
                <div className="content d-block">
                  <p className="first mb-0 mr-4">{t("Insurance letter")}</p>
                </div>
                <div
                  className="image"
                  data-toggle="tooltip"
                  data-placement="top"
                  title={t("Download PDF")}
                >
                  <a
                    href={FörsäkringsbrevTryggHansa}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button className="theme_btn">
                      <FiDownload size={20} />
                    </Button>{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <h2 className="purple h1_head mt-3">
            {t(
              "What insurances are included for self-employed individuals at Invozio?"
            )}
          </h2>
          <p className="mt-0">
            {t(
              "Invozio ensures you have a solid safety net by offering the following insurances:"
            )}
          </p>
          <h3 className="purple h1_head mt-2">{t("Liability Insurance")}</h3>
          <p className="mt-0">
            {t(
              "Invozio's liability insurance covers compensation claims for personal injury and property damage that may arise during your work. The insurance has a compensation limit of 10,000,000 SEK and protects you if you cause damage to a client's property or losses due to mistakes in your work. This insurance is valid worldwide, with the exception of the USA and Canada."
            )}
          </p>
          <h4 className="purple mt-3">{t("Coverage area")}</h4>

          <ul>
            <li className="self_emp_list">
              {t("Damage to the client's property")}
            </li>

            <li className="self_emp_list">
              {t("Economic losses caused by mistakes")}
            </li>

            <li className="self_emp_list">
              {t("Geographical scope: worldwide (excluding the USA/Canada)")}
            </li>
          </ul>
        </div>

        <div className="with_background">
          <h3 className="purple">{t("Accident insurance")}</h3>
          <p className="insurance_para">
            <p className="insurance_para">
              {t(
                "Accidents can occur while working or traveling for work, which is why Invozio offers a collective accident insurance policy. This insurance covers you for accidents that happen during working hours and provides compensation for both medical and economic disability. The coverage amounts to 18 base amounts for medical disability and 36 base amounts for economic disability, providing solid protection in case of an accident."
              )}
            </p>
          </p>
          <h4 className="purple mt-3">{t("What does the insurance cover?")}</h4>

          <ul>
            <li className="self_emp_list">
              {t("Medical and economic disability")}
            </li>

            <li className="self_emp_list">
              {t("Applicable during working hours and travel for work")}
            </li>
          </ul>
        </div>

        <div className="with_background">
          <h3 className="purple h1_head">{t("Legal expenses insurance")}</h3>
          <p>
            {t(
              "Sometimes legal disputes can arise, even when working as a self-employed person. Invozio's legal expenses insurance covers legal costs up to 20 price base amounts if you find yourself in a legal dispute related to your professional activities. The deductible is 0.2 price base amounts, and the insurance is valid within the Nordic countries."
            )}
          </p>
          <h4 className="purple mt-3">{t("Coverage area")}</h4>

          <ul>
            <li className="self_emp_list">
              {t("Legal costs up to 20 base amounts")}
            </li>

            <li className="self_emp_list">
              {t("Deductible: 0.2 base amounts plus 20% of excess costs")}
            </li>
          </ul>

          <h3 className="purple">{t("Property crime insurance")}</h3>
          <p className="m-0">
            {t(
              "Invozo's property crime insurance protects you against financial losses resulting from property crimes or data breaches. The insurance provides up to 1,000,000 SEK in compensation, with a deductible of 0.5 base amounts. This is an important protection for those handling sensitive information or working with digital tools."
            )}
          </p>
          <h4 className="purple mt-3">{t("What does the insurance cover?")}</h4>
          <ul>
            <li className="self_emp_list">
              {t(
                "Economic losses caused by financial crimes or data breaches."
              )}
            </li>

            <li className="self_emp_list">
              {t("Deductible: 0.5 base amount.")}
            </li>
          </ul>

          <h3 className="purple">{t("Crisis Insurance")}</h3>
          <p className="mt-0">
            {t(
              "Work-related stress or traumatic events can affect your mental health. Invozio's crisis insurance covers up to 10 treatment sessions with a psychologist if you need support after a work-related incident. This coverage applies without a deductible and allows you to get help quickly."
            )}
          </p>
          <h4 className="purple mt-3">
            {t("What does the crisis insurance cover?")}
          </h4>
          <ul>
            <li className="self_emp_list">{t("Up to 10 therapy sessions")}</li>

            <li className="self_emp_list">{t("No deductible")}</li>
          </ul>

          <h3 className="purple">{t("Business Travel Insurance")}</h3>
          <p>
            {t(
              "If you travel for business, it's important to have good coverage in case something happens. Invozio's business travel insurance covers everything from medical expenses and theft of property to delayed luggage. The insurance covers personal movable property up to 60,000 SEK, with theft-prone items covered up to 20,000 SEK. The insurance also includes legal protection and personal liability coverage while on business trips."
            )}
          </p>
          <h4 className="purple mt-3">
            {t("What does the business travel insurance cover?")}
          </h4>

          <ul>
            <li className="self_emp_list">
              {t("Personal belongings: 60,000 SEK")}
            </li>
            <li className="self_emp_list">{t("Valuable items: 20,000 SEK")}</li>
            <li className="self_emp_list">
              {t("Medical and travel expenses")}
            </li>
            <li className="self_emp_list">
              {t("Legal protection and liability coverage up to 300,000 SEK")}
            </li>
          </ul>

          <h2 className="purple">
            {t("Why are insurances important for self-employed individuals?")}
          </h2>
          <p>
            {t(
              "When you are self-employed, you are responsible for your own protection, and without the right insurances, a simple mistake or accident can lead to significant costs. Invozio ensures that you as"
            )}
            <Link
              className="ml-1 mr-1"
              to={`${
                language === LOCALES.EN_US
                  ? `/self-employment?lang=${LOCALES.EN_US}`
                  : `/egenanstallning?lang=${LOCALES.SV_SE}`
              }`}
              style={{ textDecoration: "underline" }}
            >
              {t("self-employed")}
            </Link>
            {t(
              "is protected with a complete insurance package, so you can work safely without worrying about financial risks. Whether it involves liability claims, accidents, or legal disputes, you have the insurance coverage you need."
            )}
          </p>
          <h2>{t("How you can benefit from Invozio's insurance")}</h2>
          <p>
            {t(
              "The insurances offered by Invozio are automatically included when you invoice through our service. You don’t need to worry about taking out separate insurance policies or managing additional administration. By using Invozio's platform, you gain access to comprehensive protection that helps you focus on your work without having to worry about potential risks."
            )}
          </p>
          <h2>{t("Security and safety with Invozio's insurances")}</h2>
          <p>
            {t(
              "Being self-employed and invoicing without a company gives you great flexibility, but it also requires good insurance coverage. Invozio offers comprehensive insurance that covers everything from liability for damages to protection against accidents and legal disputes. By choosing Invozio, you not only get a simple invoicing solution but also the peace of mind of being insured against the most common risks that may arise in the workplace."
            )}
          </p>

          <div className="text-center mt-4 mb-3">
            <Button
              className="mt-3 mb-4 create-account filled home_create_account"
              onClick={() => {
                navigate(
                  language === LOCALES.EN_US
                    ? `/contact-us?lang=${LOCALES.EN_US}`
                    : `/kontakta-oss?lang=${LOCALES.SV_SE}`
                );
                sessionStorage.setItem("accountType", 1);
              }}
            >
              {t("Contact us with any questions about insurance")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

const Insurances = () => {
  const insuranceImage = `${blobURL}/insurance.jpg`;

  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const user = useSelector((state) => state.auth.user);

  const location = useLocation();
  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className={
        location.pathname.includes("dashboard") ||
        location.pathname.includes("instrumentbrada")
          ? "my-customers-table new_desgn_insurance jggu mt-5 invoice-space2 ins-space new_nw"
          : "my-customers-table new_desgn_insurance jggu mt-5 invoice-space2 ins-space"
      }
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link rel="canonical" href="https://invozio.com/insurance" />
        ) : (
          <link rel="canonical" href="https://invozio.com/forsakring" />
        )}
      </Helmet>
      <section className="insurns_wrap rg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="txt_wrap">
                <h1 className="security_about text-uppercase mb-0">
                  {t("Insurance")}
                </h1>
                <h3 className="fnt_family">
                  {t(
                    "Those who work via Invozio always have good basic protection via basic insurance that covers your basic needs"
                  )}
                </h3>
                {!user && (
                  <Button
                    variant=""
                    className="mt-3 new_theme_btn "
                    onClick={() =>
                      navigate(
                        language === LOCALES.EN_US
                          ? `/emailregister?lang=${LOCALES.EN_US}`
                          : `/e-postregister?lang=${LOCALES.SV_SE}`
                      )
                    }
                  >
                    {t("Create Free Account")}
                  </Button>
                )}
              </div>
              <div className="mt-4">
                <h3>
                  {" "}
                  {t(
                    "Have you been involved in an accident or caused damage?"
                  )}{" "}
                </h3>
                <p style={{ fontSize: "16px" }}>
                  {t(
                    `If so, it's important to report the incident to Trygg-Hansa promptly. When completing your claim, please include our contract number 25-2738090-08 and the company name Invozio LV SIA, along with our organization number 502085-4062. This ensures that Trygg-Hansa can process your claim efficiently and accurately. Use the following link to submit your claim:`
                  )}
                  <Link
                    style={{ color: "#0000EE", textDecoration: "underline" }}
                    target="_blank"
                    to="https://www.trygghansa.se/skadeanmalan/anmal-en-skada/fritext#/"
                  >
                    {" "}
                    https://www.trygghansa.se/skadeanmalan/anmal-en-skada/fritext#/{" "}
                  </Link>
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="image_wrap">
                <img
                  src={insuranceImage}
                  alt="insurance"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <InsuranceContent />
    </Layout>
  );
};

export default Insurances;
